<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Atividade coletiva - Inconsistências"
    >
        <template v-if="data">

            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />

            <rkm-area
                title="Cadastro"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Data"
                            :value="data.cadastro.campos.dataAtendimento"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="PSE educação"
                            :value="data.cadastro.campos.pseEducacao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="PSE saúde"
                            :value="data.cadastro.campos.pseSaude"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="INEP"
                            :value="data.cadastro.campos.inep"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Outra localidade"
                            :value="data.cadastro.campos.outraLocalidade"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.cadastro.campos.cnesLocalAtividade"
                        />
                    </rkm-col>

                    <rkm-col cols="10">
                        <Item
                            label="Turno"
                            :value="data.cadastro.campos.turno"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.cadastro.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Profissionais"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissionalResponsavel.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNS"
                            :value="data.profissionalResponsavel.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNES"
                            :value="data.profissionalResponsavel.campos.cnes"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="IBGE"
                            :value="data.profissionalResponsavel.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="INE"
                            :value="data.profissionalResponsavel.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissionalResponsavel.campos.cboCodigo2002"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissionalResponsavel.inconsistencias" />

                <rkm-area title="Outros profissionais">
                    <rkm-table
                        hide-filters
                        hide-pagination
                        :items="data.outrosProfissionais.lista"
                        :fields="[
                            { key: 'nomeProfissional', label: 'Nome' },
                            { key: 'cnsProfissional', label: 'CNS' },
                            { key: 'codigoCbo2002', label: 'CBO' },
                        ]"
                    />

                    <Inconsistencia :inconsistencias="data.outrosProfissionais.inconsistencias" />
                </rkm-area>
            </rkm-area>

            <rkm-area
                title="Atividade"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Atividade"
                            :value="data.atividade.campos.atividadeTipo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Participantes"
                            :value="data.atividade.campos.numParticipantes"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Avaliações alteradas"
                            :value="data.atividade.campos.numAvaliacoesAlteradas"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="data.atividade.campos.showTemasReuniao"
                title="Temas para reunião"
                type="fieldset"
            >
                <rkm-table
                    hide-filters
                    hide-pagination
                    :items="data.temasReuniao.lista.map(value => ({ value }))"
                    :fields="[{ key: 'value', label: 'Tema' }]"
                />

                <Inconsistencia :inconsistencias="data.temasReuniao.inconsistencias" />
            </rkm-area>

            <rkm-area
                v-if="data.atividade.campos.showPublicoAlvoTemasSaude"
                title="Público alvo"
                type="fieldset"
            >
                <rkm-table
                    hide-filters
                    hide-pagination
                    :items="data.publicoAlvo.lista.map(value => ({ value }))"
                    :fields="[{ key: 'value', label: 'Publico alvo' }]"
                />

                <Inconsistencia :inconsistencias="data.publicoAlvo.inconsistencias" />
            </rkm-area>

            <rkm-area
                v-if="data.atividade.campos.showPublicoAlvoTemasSaude"
                title="Temas para saúde"
                type="fieldset"
            >
                <rkm-table
                    hide-filters
                    hide-pagination
                    :items="data.temasSaude.lista.map(value => ({ value }))"
                    :fields="[{ key: 'value', label: 'Tema' }]"
                />

                <Inconsistencia :inconsistencias="data.temasSaude.inconsistencias" />
            </rkm-area>

            <rkm-area
                v-if="data.atividade.campos.showPraticasSaude"
                title="Práticas em saúde"
                type="fieldset"
            >
                <rkm-table
                    hide-filters
                    hide-pagination
                    :items="data.praticasSaude.lista.map(value => ({ value }))"
                    :fields="[{ key: 'value', label: 'Prática' }]"
                />

                <Inconsistencia :inconsistencias="data.praticasSaude.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Participantes"
                type="fieldset"
            >
                <rkm-list
                    hide-pagination
                    hide-filters
                    :items="atendimentosComInconsistencia"
                    class="p-0"
                >
                    <template v-slot="{ item }">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Paciente:</strong> {{ item.campos.nomeParticipante }}
                            </rkm-col>

                            <rkm-col>
                                <strong>CNS:</strong> {{ item.campos.cnsParticipante }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Data de nascimento:</strong> {{ item.campos.dataNascimento }}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-3">
                            <rkm-row>
                                <rkm-col cols="3">
                                    <Item
                                        label="CNS"
                                        :value="item.campos.cnsParticipante"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="CPF"
                                        :value="item.campos.cpfParticipante"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="Data de nascimento"
                                        :value="item.campos.dataNascimento"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="Alterada"
                                        :value="item.campos.avaliacaoAlterada"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="2">
                                    <Item
                                        label="Peso (kg)"
                                        :value="item.campos.peso"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        label="Altura (cm)"
                                        :value="item.campos.altura"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="Parou de fumar"
                                        :value="item.campos.cessouHabitoFumar"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        label="Abandonou grupo"
                                        :value="item.campos.abandonouGrupo"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        label="Sexo"
                                        :value="item.campos.sexo"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <Inconsistencia :inconsistencias="item.inconsistencias" />
                        </div>
                    </template>
                </rkm-list>

                <Inconsistencia :inconsistencias="data.participantes.inconsistencias" />
            </rkm-area>
        </template>


        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        inconsistenciaVersao(){
            const texto = this.inconsistencia?.inconsistencia || ''
      

            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`        
            ]
        
        },
        atendimentosComInconsistencia(){
            return this.data.participantes.lista.map(item => ({
                ...item, 
                _listItemColor: this.isInconsistencia(item) ? 'danger': ''
            }))
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        isInconsistencia(item){

            const blocos = [
                item.abandonouGrupo,
                item.altura,
                item.exames,
                item.avaliacaoAlterada,
                item.cessouHabitoFumar,
                item.cnsParticipante,
                item.cpfParticipante,
                item.dataNascimento,
                item.nomeParticipante,
                item.peso,
                item.sexo
            ]

            return blocos.some(b => (b?.inconsistencias?.length || 0) > 0)
        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },
    
        extrairVersao(texto){
            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
    },
    mixins: [repository, error]
}
</script>